import { useQuery } from "react-query";
import Cookies from "js-cookie";
import { serverBaseUrl } from "../config/envs";

const getCollabList = async ({ token = null }) => {
  let headers = {
    "Content-Type": "application/json",
  };
  if (token) {
    headers["Authorization"] = `Bearer ${token}`;
  }

  const response = await fetch(`${serverBaseUrl}/get_collab_phys_list`, {
    headers,
  });

  if (!response.ok) {
    let errorData = {
      status: response?.status,
      message: response?.statusText,
    };

    try {
      const json = await response.json();
      errorData.message = json.message || errorData.message;
      errorData.messageCode = json.messageCode;
      errorData.data = json.data;
      errorData.success = json.success;
    } catch (jsonError) {
      console.error("Failed to parse JSON error response:", jsonError);
    }

    throw new Error(JSON.stringify(errorData));
  }

  return response.json();
};

export const useGetCollabList = () => {
  const token = Cookies.get("token");

  return useQuery(["get_collab_phys_list"], () => getCollabList({ token }), {});
};
